import { registerPageInit } from '../barba/page-init-registry';
import '../../css/pages/about/about-faq.scss';

class AboutFaq {
  constructor() {}

  public init(): void {}
}

registerPageInit('about-faq', () => {
  const page = new AboutFaq();
  page.init();
});
